import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api } from "../../lib/api";
import { Calendar, MapPin, Search, ArrowRight } from "lucide-react";

function EventGrid({ items }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((e, i) => {
        const d = new Date(e.event_date);
        return (
          <FadeUp key={e.id} delay={i * 0.03} className="card-elev group flex flex-col">
            {e.banner && <div className="aspect-[16/9] overflow-hidden relative">
              <img src={e.banner} alt={e.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute top-4 left-4 bg-white rounded-lg shadow-lg px-3 py-2 text-center">
                <div className="text-[10px] uppercase text-brand-muted">{d.toLocaleString("en", { month: "short" })}</div>
                <div className="font-serif text-xl font-bold text-brand-primary leading-none">{d.getDate()}</div>
              </div>
            </div>}
            <div className="p-6 flex flex-col flex-1">
              <span className={`self-start text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5 rounded-full ${e.status === "upcoming" ? "bg-brand-accent/10 text-brand-accent" : "bg-brand-muted/10 text-brand-muted"}`}>{e.status}</span>
              <h3 className="font-serif text-lg font-bold text-brand-text mt-3 leading-snug line-clamp-2">{e.title}</h3>
              <div className="text-sm text-brand-muted mt-3 flex items-center gap-1.5"><MapPin size={14} /> {e.venue}</div>
              <div className="text-sm text-brand-muted mt-1 flex items-center gap-1.5"><Calendar size={14} /> {d.toLocaleDateString()} • {e.event_time}</div>
              <Link to={`/events/${e.slug}`} className="mt-auto pt-4 inline-flex items-center gap-1.5 text-brand-primary font-semibold text-sm">View details <ArrowRight size={14} /></Link>
            </div>
          </FadeUp>
        );
      })}
      {items.length === 0 && <div className="col-span-full text-center text-brand-muted py-16">No events found.</div>}
    </div>
  );
}

export default function Events() {
  const [tab, setTab] = useState("upcoming");
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      const params = new URLSearchParams({ status: tab });
      if (q) params.set("q", q);
      params.set("category", "Event");
      api.get(`/events?${params}`).then((r) => setItems(r.data.items || []));
    }, 250);
    return () => clearTimeout(t);
  }, [tab, q]);

  return (
    <div>
      <PageHero title="Events" subtitle="Scientific conferences, symposia, and society gatherings." breadcrumbs={["Home", "Events"]} />
      <section className="section container-page">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <div className="inline-flex rounded-lg bg-white border border-brand-border p-1">
            {["upcoming", "past"].map((t) => (
              <button key={t} onClick={() => setTab(t)} className={`px-5 py-2 rounded-md text-sm font-semibold transition-colors ${tab === t ? "bg-brand-primary text-white" : "text-brand-text hover:bg-brand-primary-light"}`} data-testid={`events-tab-${t}`}>{t === "upcoming" ? "Upcoming" : "Past Events"}</button>
            ))}
          </div>
          <div className="relative w-full sm:max-w-xs">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search events…" className="form-input pl-9" data-testid="events-search" />
          </div>
        </div>
        <EventGrid items={items} />
      </section>
    </div>
  );
}
